import EvalPage from '@/views/evaluations/evalPage.vue'
import Evaluations from '@/views/evaluations/evalEvaluationsTab.vue'
import EvaluationsTable from '@/views/evaluations/evalEvaluationsTable.vue'
import Goals from '@/views/evaluations/evalGoalsTab.vue'
import StrengthsBarriers from '@/views/evaluations/evalStrengthsBarriersTab.vue'
// import { state } from '@/views/etar/etarStore'

export default [
  {
    path: '/evals',
    name: 'Evaluations',
    component: EvalPage,
    redirect: '/evals/evaluations',
    meta: {
      title: 'Evaluations',
      childrenInNav: false,
      requiresAuth: true,
      authorizedUsers: [5],
    },
    children: [
      {
        path: '/evals/evaluations',
        name: 'Evaluations ',
        component: Evaluations,
        meta: {
          requiresAuth: true,
          authorizedUsers: [5],
        },
        children: [
          {
            path: '/evals/evaluations/:evalDetId',
            name: 'EvalTable',
            component: EvaluationsTable,
            props: true,
            meta: {
              title: 'Evaluations',
              requiresAuth: true,
              authorizedUsers: [5],
            },
          },
        ],
      },
      {
        path: '/evals/goals',
        name: 'Goals',
        component: Goals,
        meta: {
          title: 'Goals',
          requiresAuth: true,
        },
      },
      {
        path: '/evals/strengths-barriers',
        name: 'Strengths/Barriers',
        component: StrengthsBarriers,
        meta: {
          title: 'Strengths and Barriers',
          requiresAuth: true,
        },
      },
    ],
  },
]
